export const createPageUrl = (pageName) => {
  const name = pageName.toLowerCase();
  if (name === 'home') return '/';
  if (name === 'localarea') return '/local-area';
  if (name === 'usefulinformation') return '/useful-information';
  return `/${name}`;
};
